export default {
	italian: "Italiano",
	english: "Inglés",
	japanese: "Japonés",
	french: "Francés",
	german: "Alemán",
	spanish: "Español",
	sun_description:
		"El sol es una estrella de tamaño medio ubicada en el centro de nuestro sistema solar. Es una fuente de luz y calor que sustenta la vida en la Tierra. Compuesto principalmente por hidrógeno y helio, genera energía a través de la fusión nuclear. Su masa y gravedad mantienen en órbita a los planetas y otros cuerpos celestes en el sistema solar.",

	// Common UI Elements
	save: "Guardar",
	delete: "Eliminar",
	close: "Cerrar",
	clear: "Limpiar",
	cancel: "Cancelar",
	next: "Siguiente",
	back: "Atrás",
	done: "Hecho",
	search: "Buscar...",

	// Authentication
	email: "Correo electrónico",
	password: "Contraseña",
	remember_me: "Recordarme",
	forgot_password: "¿Olvidaste tu contraseña?",
	sign_in: "Iniciar sesión",
	email_required: "El correo electrónico es requerido",
	password_required: "La contraseña es requerida",
	check_username_password: "¡Por favor verifica tu nombre de usuario y contraseña!",

	// Profile
	member_type: "Tipo de miembro",
	location: "Ubicación",
	copy_jwt: "Copiar JWT",
	edit_profile_image: "Editar imagen de perfil",
	public_profile: "Perfil público",
	club_profile: "Perfil del club",
	open_position: "Posición abierta",
	career_profile: "Perfil de carrera",
	contractual_data: "Datos contractuales",
	account_information: "Información de la cuenta",
	security: "Seguridad",

	// Profile Form Fields
	phone: "Teléfono",
	street: "Calle",
	zip: "Código postal",
	town: "Ciudad",
	add_phone_number: "Agrega tu número de teléfono",
	add_street_address: "Agrega tu dirección",
	add_zip_code: "Agrega tu código postal",
	add_town: "Agrega tu ciudad",
	add_first_name: "Agrega tu nombre",
	add_last_name: "Agrega tu apellido",
	additional_citizenship: "Ciudadanía adicional",
	select_additional_citizenship: "Selecciona ciudadanía adicional",
	add_instagram_handle: "Agrega tu usuario de Instagram",
	add_wechat_handle: "Agrega tu usuario de WeChat",
	add_facebook_url: "Agrega la URL de tu página de Facebook",
	add_bluesky_handle: "Agrega tu usuario de Bluesky",
	add_twitter_handle: "Agrega tu usuario de X / Twitter",
	add_website_url: "Agrega la URL de tu sitio web aquí",

	// Player Stats
	current_world_ranking: "Tu clasificación mundial actual",
	best_world_ranking: "Mejor clasificación mundial",
	current_world_ranking_placeholder: "¿Cuál es tu clasificación mundial actual?",
	best_world_ranking_placeholder: "¿Cuál fue tu mejor clasificación mundial?",
	other_successes: "Otros éxitos",
	continent: "Continente",
	current_continent_ranking: "Tu clasificación actual en este continente",
	country: "País",
	club_name: "Nombre del club",
	minimum_salary_per_game: "Salario mínimo por juego (USD)",

	// Trainer Stats
	salary_usd: "Salario en USD",
	license_level: "Nivel de licencia",
	add_current_salary: "Agrega tu salario actual",
	add_license_level: "Agrega tu nivel de licencia",

	// Club Open Positions
	open_for_players: "Abierto para jugadores",
	open_until_date: "Abierto hasta la fecha",
	additional_information: "Información adicional",
	save_open_positions: "Guardar posiciones abiertas",

	// Search and Filters
	search_for_name: "Buscar por nombre",
	search_for_country: "Buscar por país",
	filter_category: "Filtrar categoría",
	advanced_search: "Búsqueda avanzada",
	min_world_ranking: "Clasificación mundial mín.",
	min_us_points: "Puntos US mín.",
	min_continental_ranking: "Clasificación continental mín.",
	select_continent: "Seleccionar continente",
	min_salary_per_game: "Salario mín. por juego (USD)",
	max_salary: "Salario máx. (USD)",
	select_license_level: "Nivel de licencia",
	select_language: "Idioma",

	// Messages and Notifications
	failed_to_update_image: "Error al actualizar la imagen",
	error_submitting_form: "Error al enviar el formulario",
	access_denied_club_users: "Acceso denegado. Solo los usuarios del club pueden acceder a las posiciones abiertas.",
	token_copied: "✅ ¡Token copiado!",
	token_copy_failed: "❌ No se pudo copiar el token",
	web_push_subscription_inactive: "Tienes una suscripción de notificaciones web pero no está activa. Por favor cierra sesión e inicia sesión nuevamente para activarla.",

	// Page Titles
	multi_language: "Multi idioma",
	not_found: "404 No encontrado",

	// Form Elements
	column_title: "Título de columna...",
	task_title: "Título de tarea...",
	meaningful_title_hint: "¿De qué debería tratar esto? ¡Agrega un título significativo aquí!",
	meaningful_title_placeholder: "¿De qué debería tratar esto? ¡Agrega un título significativo aquí!",
	message: "Mensaje...",

	// Chat Messages
	you_did_not_start_conversation: "Aún no has iniciado una conversación.",
	head_over_community_pages: "¡Por favor ve a las páginas de la comunidad para iniciar una nueva conversación con uno de nuestros miembros!",
	select_a_conversation: "Selecciona una conversación",
	select_a_contact: "Selecciona un Contacto",
	start_new_chat_with: "Inicia un nuevo chat con '{name}' enviando un nuevo mensaje",

	// Profile Personal
	public_information: "Información pública",
	other_members_can_see_personal_info: "Otros miembros de nuestra comunidad pueden ver esta información personal.",
	socials: "Redes sociales",
	website: "Sitio web",
	other_profiles_video_urls: "Otros perfiles y URLs de video",
	which_country_live: "¿En qué país vives?",
	citizenship: "Ciudadanía",
	instagram: "Instagram",
	wechat: "WeChat",
	facebook: "Facebook",
	threads: "Threads",
	bluesky: "BlueSky",
	x_twitter: "X / Twitter",
	external_profile_urls: "URLs de perfiles externos",
	external_video_urls: "URLs de videos externos",
	bio: "Biografía",

	// Validation
	valid: "Válido",
	invalid: "Inválido",

	// Tour Guide
	logo: "Logo",
	breadcrumb: "Navegación",
	latest_pinned_pages: "Páginas recientes/Fijadas",

	// Demo Content
	icons: "Iconos",
	basic: "Básico",
	carousel: "Carrusel",
	play: "Reproducir",
	refresh_view_tool: "Herramienta de actualizar vista",
	stoner: "Stoner",
	refresh_view: "Actualizar vista",

	// Auth Form
	welcome_to_ttpronet: "Bienvenido a TTProNet",
	be_part_of_ttpronet: "Forma parte de TTProNet",
	forgot_your_password: "¿Olvidaste tu contraseña?",
	created_by_robert_gardos: "Creado por Robert Gardos",
	register_for_free: "¡Regístrate gratis!",
	password_reset_instruction: "Ingresa tu dirección de correo electrónico y te proporcionaremos un enlace para restablecer tu contraseña.",
	dont_have_account: "¿No tienes una cuenta?",
	sign_up: "Registrarse",
	back_to_sign_in: "Volver a iniciar sesión",
	do_you_have_account: "¿Tienes una cuenta?",
	send_reset_link: "Enviar Enlace de Restablecimiento",

	// Sign Up Form
	select_your_country: "Selecciona tu país",
	confirm_password: "Confirmar Contraseña",
	enter_password_again: "Por favor ingresa la contraseña nuevamente",
	register_as: "Quiero registrarme como...",
    player: "Player",
    trainer: "Trainer",
    manager: "Manager",
    club: "Club",
	first_name: "Nombre",
	last_name: "Apellido",
	birthdate: "Fecha de nacimiento",
	agree_to: "Acepto los",
	terms_of_use: "términos de uso",
	create_account: "Crear una cuenta",
	password_requirements: "Al menos 8 caracteres<br>Mín. 1 letra<br>Mín. 1 número<br>Mín. 1 carácter especial",
	register_explore_upgrade: "¡Regístrate gratis y explora TTProNet! ¡Actualiza a una cuenta completa en cualquier momento para desbloquear aún más funciones!",
	please_select: "¡Por favor selecciona!",

	// Sign Up Success
	account_created_successfully: "¡Cuenta Creada Exitosamente!",
	welcome_to_ttpronet_success: "¡Bienvenido a TTProNet! Tu cuenta ha sido creada y estás listo para comenzar a explorar nuestra plataforma. Te hemos enviado un correo de confirmación con un enlace para activar tu cuenta.",
	go_to_login: "Ir al Login",

	// Sign Up Warning
	account_created_warning: "Cuenta Creada con Advertencia",
	account_created_email_failed: "Tu cuenta ha sido creada exitosamente, pero no pudimos enviar el correo de confirmación. Por favor usa la función de restablecimiento de contraseña o contáctanos para asistencia.",
	reset_password: "Restablecer Contraseña",

	// Profile Components
	account_information_description: "Estos campos solo son utilizados por TTProNet. Los miembros de la comunidad <b>no</b> pueden ver esta información, excepto el país donde vives - esta información es pública.",
	contractual_information: "Información Contractual",
	contractual_information_description_trainer: "Estos valores no se muestran directamente, pero pueden ayudar a jugadores y clubes a encontrarte.",
	contractual_information_description_player: "Estos valores no se muestran directamente, pero pueden ayudar a entrenadores, managers y clubes a encontrarte.",
	contractual_information_description_manager: "Estos valores no se muestran directamente, pero pueden ayudar a jugadores, entrenadores y clubes a encontrarte.",
	club_information: "Información del club",
	club_information_description: "Otros miembros de nuestra comunidad pueden ver esta información del club.",
	club_location_question: "¿En qué país está ubicado el club?",
	rankings_and_memberships: "Rankings y Membresías",
	rankings_memberships_description: "Otros miembros de nuestra comunidad pueden ver estas informaciones:",
	your_current_us_points: "Tus puntos US actuales",
	most_us_points: "Máximo de puntos US",
	continental_rankings: "Rankings continentales",
	regional_rankings: "Rankings regionales",
	i_play_for_these_clubs: "Juego para estos clubes:",
	your_club_not_in_list: "¿Tu club no está en nuestra lista?",
	club_not_in_list_description: "¡Por favor ingresa el país y el nombre de tu club y lo agregaremos por ti!",
	leagues_i_play_in: "Ligas en las que juego:",
	league_not_listed: "¿Estás jugando en una liga que no está listada?",
	league_not_listed_description: "¡Solo ingresa el nombre(s) de la(s) liga(s) en la(s) que juegas aquí!",
	managing_fee_percent: "Tarifa de gestión en %",
	open_position_management: "Gestión de Posiciones Abiertas",
	open_position_management_description: "Gestiona si tu club actualmente está aceptando nuevos entrenadores y jugadores.",
	open_for_players_section: "Abierto para Jugadores",
	open_for_trainers_section: "Abierto para Entrenadores",
	open_for_trainers: "Abierto para entrenadores",
	password_section: "Contraseña",
	password_description: "Por favor usa una contraseña segura para la seguridad de tu propia cuenta.",
	repeat_password_confirmation: "Repite la contraseña para confirmación",
	identity_verification: "Verificación de identidad",
	identity_verification_description: "Subir un documento personal para verificar tu identidad no es requerido por defecto. Sin embargo, para habilitar ciertas características, esto puede ser necesario. Por favor solo sube tu documento si nuestro equipo de soporte lo solicita específicamente.",
	document_pdf: "Documento (.pdf)",
	click_or_drag_file: "Haz clic o arrastra un archivo a esta área para subir",
	upload_starts_immediately: "La subida comenzará inmediatamente después de seleccionar o arrastrar el archivo.",
	failed_to_load_club_positions: "Error al cargar las posiciones abiertas del club",
	unauthorized: "No autorizado",
	access_denied_club_update: "Acceso denegado. Solo los usuarios del club pueden actualizar las posiciones abiertas.",
	error_updating_open_positions: "Error al actualizar las posiciones abiertas",

	// Validation Messages
	country_required: "El país es requerido",
	password_confirmation_required: "La confirmación de contraseña es requerida",
	passwords_not_match: "¡La contraseña no coincide con la contraseña ingresada nuevamente!",
	please_input_name: "Por favor ingresa tu nombre",
	please_input_age: "Por favor ingresa tu edad",
	please_input_number: "Por favor ingresa tu número",
	please_add_phone_number: "Por favor agrega tu número de teléfono",
	please_add_street_address: "Por favor agrega tu dirección",
	please_add_zip_code: "Por favor agrega tu código postal",
	please_add_town: "Por favor agrega tu ciudad",
	please_input_first_name: "Por favor ingresa tu nombre",
	please_input_last_name: "Por favor ingresa tu apellido",
	please_add_country: "Por favor agrega tu país",
	please_set_password: "Por favor establece tu contraseña",
	please_enter_password_twice: "Por favor ingresa tu contraseña dos veces para confirmar",
	please_input_event_title: "Por favor ingresa el título del evento",

	// Greetings
	good_morning: "Buenos días",
	hi: "Hola",
	good_evening: "Buenas tardes",

	// Notifications
	notifications: "Notificaciones",
	details: "Detalles",
	no_notifications: "No hay notificaciones",
	mark_all_as_read: "Marcar todo como leído",

	// News
	read_more: "¡Leer más!",

	// Placeholders - Common
	email_example: "example_at_email.com",
	select_profile_picture: "Selecciona tu foto de perfil",

	// Placeholders - Personal Info
	type_short_bio: "¡Escribe una biografía corta que todos puedan leer sobre ti!",
	add_club_name: "Agrega el nombre de tu club",
	use_strong_password: "¡Usa una contraseña segura!",
	repeat_password: "Repite la contraseña",

	// Placeholders - Social Media
	type_threads: "Escribe threads",
	add_url_here: "Agrega una URL aquí",

	// Placeholders - Profile Stats
	current_world_ranking_question: "¿Cuál es tu clasificación mundial actual?",
	best_world_ranking_question: "¿Cuál fue tu mejor clasificación mundial?",
	us_points_current: "¿Cuántos puntos US tienes actualmente?",
	us_points_maximum: "¿Cuál fue tu máximo de puntos US?",
	describe_other_successes: "Describe otros éxitos tuyos - ubicaciones, clasificaciones, etc.",
	continent_placeholder: "Continente",
	current_continent_ranking_placeholder: "Tu clasificación actual en este continente",
	region_placeholder: "Región (ej. país, estado)",
	current_region_ranking_placeholder: "Tu clasificación actual en esta región",
	league_name_placeholder: "Nombre de la liga",
	salary_per_game_placeholder: "Agrega tu salario mínimo por juego en",
	managing_fee_placeholder: "Agrega tu tarifa de gestión en %",

	// Placeholders - Kanban
	column_title_placeholder: "Título de columna...",
	task_title_placeholder: "Título de tarea...",

	// Placeholders - Calendar
	event_title_placeholder: "Título del Evento",
	event_location_placeholder: "Ubicación del Evento",
	event_description_placeholder: "Descripción del Evento",

	// Placeholders - Club Positions
	select_end_date: "Seleccionar fecha de fin",
	player_position_info: "Proporciona información adicional sobre las posiciones de jugadores (requisitos, nivel, etc.)",
	trainer_position_info: "Proporciona información adicional sobre las posiciones de entrenadores (requisitos, nivel de experiencia, etc.)",

	// Placeholders - Security/Documents
	document_types_placeholder: "Por favor usa cualquiera de los tipos de documento mencionados",
	photo_id_placeholder: "Pasaporte, Cédula de identidad, Licencia de conducir, etc.",

	// Placeholders - Email
	email_subject_placeholder: "Asunto del mensaje...",

	// Community Pages
	find_your_next_manager: "¡Encuentra tu próximo manager!",
	get_in_contact_with_trainers: "¡Ponte en contacto con entrenadores!",
	find_players_around_world: "¡Encuentra jugadores de todo el mundo!",
	looking_for_clubs: "¿Buscas clubes?",
	clear_all: "Limpiar todo",

	// Academy Pages
	lessons: "Lecciones",
	download: "Descargar",
	open_in_browser: "Abrir en navegador",
	upgrade_now_activate_downloads: "¡Actualiza ahora para activar las descargas!",
	content_available_for_members: "Este contenido está disponible para miembros con una suscripción activa.",

	// Forum Pages
	forum_list: "Lista del foro",
	start_a_conversation: "Iniciar una conversación",
	latest_threads: "Últimos hilos",
	me: "Yo",
	add_a_new_post: "Agregar una nueva publicación",
	send: "Enviar",

	// API Response Messages - Authentication
	auth: {
		user_not_authenticated: "Usuario no autenticado"
	},

	// API Response Messages - Forms
	form: {
		// Password-related messages
		password_confirmation_required: "La contraseña y confirmación son requeridas",
		password_too_common: "¡La contraseña es muy común!",
		passwords_do_not_match: "Las contraseñas no coinciden",
		password_updated_successfully: "Contraseña actualizada exitosamente",
		password_reset_sent_successfully: "Solicitud de restablecimiento de contraseña para \"{email}\" enviada exitosamente",
		password_reset_failed: "Falló la solicitud de restablecimiento de contraseña para \"{email}\"",
		password_validation_failed: "Asegúrese de que su contraseña cumple los requisitos.",

		// User information messages
		information_updated_successfully: "Información actualizada exitosamente",
		invalid_request: "Solicitud inválida",

		// Registration messages
		email_already_exists: "¡Esta dirección de correo electrónico ya está en uso! ¿Quizás intentar restablecer tu contraseña?",
		invalid_role: "¡Rol inválido!",
		date_of_birth_required: "¡La fecha de nacimiento no debe estar vacía!",
		minimum_age_required: "¡Debes tener al menos 13 años de edad!",
		name_required: "¡El nombre y apellido no deben estar vacíos!",
		terms_acceptance_required: "¡Debes aceptar los términos y condiciones!",
		email_send_failed: "Error al enviar el correo de confirmación",
		registration_successful_with_warning: "Registro exitoso pero con advertencias",
		registration_failed: "Error en el registro",
		registration_error_occurred: "Ocurrió un error durante el registro",
		invalid_credentials: "Credenciales inválidas",

        // API error messages, they cannot be replaced with the translation keys
		"Invalid credentials.": "Credenciales inválidas"
	}
}
